import { CONFIG_PAGE_PATH } from '../../Routing/paths';
import {
  PC_USER_ROLES,
  PLANNING_ROLES,
} from '../../pages/LoginProvider/constants';

export const PRODUCTION_PLANNING_TABS_CONFIG = {
  RETAIL: {
    value: 'RETAIL',
    label: 'Retail',
    isParent: true,
    roles: [
      PLANNING_ROLES.RETAIL_PLANNER,
      PLANNING_ROLES.SUPER_PLANNER,
      PLANNING_ROLES.RETAIL_AM_IST_OUTWARD_UPLOAD,
    ],
    children: {
      RETAIL_DATA_INPUT: {
        value: 'RETAIL_DATA_INPUT',
        url: '/production-planning/retail-data-input',
        label: 'Retail Data Input',
        roles: [PLANNING_ROLES.RETAIL_PLANNER],
      },
      RETAIL_PLAN: {
        value: 'RETAIL_PLAN',
        url: '/production-planning/retail-plan',
        label: 'Retail Production Plan',
        roles: [PLANNING_ROLES.RETAIL_PLANNER, PLANNING_ROLES.SUPER_PLANNER],
      },
      RETAIL_IST_OUTWARD_UPLOAD: {
        value: 'RETAIL_IST_OUTWARD_UPLOAD',
        url: '/production-planning/retail-ist-outward-upload',
        label: 'Retail IST Outward Upload',
        roles: [PLANNING_ROLES.RETAIL_AM_IST_OUTWARD_UPLOAD],
      },
    },
  },
  DATA_INPUT: {
    value: 'DATA_INPUT',
    url: '/production-planning/data-input',
    label: 'Data Input',
    roles: [PLANNING_ROLES.PLANNER, PLANNING_ROLES.SUPER_PLANNER],
  },
  PRODUCTION_PLAN: {
    value: 'PRODUCTION_PLAN',
    url: '/production-planning/production-plan',
    label: 'Production Plan',
    roles: [
      PLANNING_ROLES.PLANNER,
      PLANNING_ROLES.SUPER_PLANNER,
      ...PC_USER_ROLES,
    ],
  },
  ARCHIVES: {
    value: 'ARCHIVES',
    url: '/production-planning/archives',
    label: 'Archives',
    roles: [
      PLANNING_ROLES.PLANNER,
      ...PC_USER_ROLES,
      PLANNING_ROLES.SUPER_PLANNER,
    ],
  },
  CONFIG: {
    value: 'CONFIG MANAGEMENT',
    url: CONFIG_PAGE_PATH,
    label: 'Config Management',
    roles: [PLANNING_ROLES.CONFIG_MANAGER],
  },
  // will be enabled post QA sign off and API integration
  // RM_PLAN: {
  //   value: "RM_PLAN",
  //   url: "/production-planning/rm-plan",
  //   label: "RM Plan",
  // },
};
